import styled from 'styled-components'
import { size } from 'ui/themes/utils'

import Icon from 'ui/blocks/Icon'
import Div from 'ui/elements/Div'

export const Period = styled.div`
  cursor: pointer;

  ${Icon} {
    font-size: 12px;
    margin: 0 ${size('margin', 'xs')};

    &:last-child {
      margin-right: 0;
    }
  }
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${size('margin', 'xs')};

  font-size: 14px;
  text-align: left;
`

export const Detail = styled(Div)`
  display: flex;
  flex: 1;
  flex-flow: row wrap;
`

export const Location = styled.p`
  font-size: 12px !important;
  line-height: 16px;
  font-weight: 400 !important;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const DateTime = styled.p`
  font-size: 13px !important;
  line-height: 16px;
  font-weight: 600 !important;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:first-letter {
    text-transform: uppercase;
  }
`

export const ChoosePeriod = styled.p`
  width: 100%;
`

export const Dates = styled.div`
  width: calc(100% - var(--minicart-padding) * 2);

  padding: 14px !important;

  font-size: 12px !important;
  line-height: 16px !important;
  text-align: center;

  background: rgba(0, 0, 0, 0.16);
  border-radius: 8px;
`

const DatesBase = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  padding-bottom: var(--minicart-padding);
`

export const WithDates = styled(DatesBase)`
  ${Icon} {
    line-height: 16px;
    align-self: flex-start;

    &:last-child {
      position: absolute;

      top: 50%;
      right: ${size('padding', 'md')};

      transform: translateY(-50%);
    }
  }
`

export const NoDates = styled(DatesBase)`
  ${Icon} {
    &:last-child {
      position: absolute;

      top: 50%;
      right: ${size('padding', 'md')};

      transform: translateY(-50%);
    }
  }
`

export const Placeholder = styled.p`
  font-size: 14px !important;
`

Period.Dates = Dates
Period.Details = Details
Period.Detail = Detail
Period.Location = Location
Period.DateTime = DateTime
Period.NoDates = NoDates
Period.WithDates = WithDates
Period.ChoosePeriod = ChoosePeriod
Period.Placeholder = Placeholder

export default Period
